export default {
  data () {
    return {
      documentsSelected: [],
      downloadZipLoading: false,
      isSent: false
    }
  },
  computed: {
    documentSelected () {
      return this.documentsSelected && this.documentsSelected.length
    }
  },
  methods: {
    downloadFile (files, filename = 'fichier', ext = '.zip') {
      this.downloadZipLoading = true
      this.$api.uploadService.downloadZip(files).then(r => {
        this.downloadZipLoading = false
        this.emulateClick(new Blob([r.data], {type: r.headers['content-type']}), filename, ext)
      }).catch(() => {
        this.downloadZipLoading = false
      })
    },
    emulateClick (blob, filename, ext) {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename + ext
      link.click()
    },
    selectedItem (value) {
      this.isSent = false
      if (this.documentsSelected.map(x => x.id).includes(value.id)) {
        let idx = this.documentsSelected.findIndex(x => x.id === value.id)
        if (idx >= 0) {
          this.documentsSelected.splice(idx, 1)
        }
      } else {
        this.documentsSelected.push(value)
      }
    },
    downloadDocuments () {
      let sentDocuments = this.documentsSelected.map(a => Object.assign({}, a))
      sentDocuments.forEach(element => {
        if (element.file.path) element.path = element.file.path
        if (element.file.filename) element.filename = element.file.filename
        delete element.id
        delete element.file
      })
      this.loading = true
      let program = 'des documents du programme ' + this.program.name
      this.$api.uploadService.postDownloadZip(sentDocuments, program).then(r => {
        let email = r.data.email
        this.loading = false
        this.isSent = true
        this.$notify({
          type: 'is-info',
          text: 'Génération en cours, le fichier sera envoyé par email à ' + email + ' d\'ici quelques minutes.'
        })
        sentDocuments = []
        this.documentsSelected = []
      }).catch(err => {
        this.loading = false
        sentDocuments = []
        this.documentsSelected = []
        console.log(err)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DownloadFileMixin.js